
import Vue from "vue";
import helpers from "../inc/helpers";
import api from "../api";

import OwnerOccupancyView from "../data/OwnerOccupancyView";

export default Vue.extend({
	name: "OwnerOccupancyCreditDetail",

	props: {
		parcelId: String,
	},

	data() {
		return {
			isLoading: true,
			taxValues: null as null | OwnerOccupancyView,
		};
	},

	mounted() {
		this.getOwnerOccupancyCreditValues(this.parcelId);
	},

	methods: {
		getOwnerOccupancyCreditValues(parcelId: string): Promise<boolean> {
			return new Promise((resolve, reject) => {
				api.getOwnerOccupancyView(parcelId).then(
					(resp: OwnerOccupancyView) => {
						this.taxValues = resp;
						this.isLoading = false;

						resolve(true);
					}
				);
			});
		},
	},

	computed: {},

	filters: {
		formatCurrency(val: string): string {
			return helpers.formatCurrency(val);
		},
	},

	watch: {
		parcelId() {
			this.getOwnerOccupancyCreditValues(this.parcelId);
		},
	},

	components: {},
});
